var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 30C0.75 13.8457 13.8457 0.75 30 0.75C46.1543 0.75 59.25 13.8457 59.25 30C59.25 46.1543 46.1543 59.25 30 59.25C13.8457 59.25 0.75 46.1543 0.75 30ZM40.757 25.4056C41.5332 24.4352 41.3759 23.0193 40.4056 22.243C39.4352 21.4668 38.0193 21.6241 37.243 22.5944L26.8134 35.6315L22.591 31.409C21.7123 30.5303 20.2877 30.5303 19.409 31.409C18.5303 32.2877 18.5303 33.7123 19.409 34.591L25.409 40.591C25.8616 41.0435 26.4854 41.2819 27.1244 41.2466C27.7634 41.2112 28.3572 40.9053 28.757 40.4056L40.757 25.4056Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckmark);
export default __webpack_public_path__ + "static/media/successCheckmark.a174d4338911c8c15751edb3b4ead836.svg";
export { ForwardRef as ReactComponent };